import tempMee from '../../../apis/tempMee';

export const REFRESH_SESSION_ENDPOINT = '/auth-service/sessions/refresh';

/**
 * Exchanges a refresh token for a new access token:
 * `POST /auth-service/sessions/refresh`.
 *
 * The refresh token travels in the body; the request carries no
 * `Authorization` (`skipAuth`), since asking the session for an access token
 * here would wait on this very refresh. A 401/403 means the refresh token is no
 * good; anything else (5xx, no response) says nothing about the session.
 *
 * @param {string} refreshToken
 * @returns {Promise<Object>} the raw token payload; see `toSessionTokens`
 */
export const refreshSession = async (refreshToken) => {
  const response = await tempMee.post(
    REFRESH_SESSION_ENDPOINT,
    { refreshToken },
    { skipAuth: true },
  );

  return response.data?.data ?? response.data;
};
